import { create } from "zustand";
import createModalSlice from "./slices/modalSlice";
import createApiSlice from "./slices/apiSlice";

// Create the Zustand store and combine slices
const useStoreHook = create((set) => ({
  ...createModalSlice(set),
  ...createApiSlice(set),
  // Add other slices here
}));

// Export the Zustand hook to be used in components
export { useStoreHook };
